import Vue from 'vue'
import IdleVue from "idle-vue";
import App from './App.vue'
import router from './router'
import store from './store'

import Vuex from 'vuex'
Vue.use(Vuex)

import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
Vue.use(Vuesax)

import 'material-icons/iconfont/material-icons.css';
import './assets/css/stylus/index.scss'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect)

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import VueFeather from 'vue-feather'
Vue.use(VueFeather)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

Vue.use(require('vue-moment'));

import VueProgressBar from "vue-progressbar";
Vue.use(VueProgressBar, {color: "#00c0b7"});

import VCalendar from 'v-calendar'
Vue.use(VCalendar)

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)

Vue.config.productionTip = false

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
if (!Vue.moment) {
  Vue.use(VueMoment, { moment })
}
const eventsHub = new Vue()
Vue.use(
  IdleVue, 
  {
    eventEmitter: eventsHub,
    store,
    idleTime: 81500000, // 10min 3 seconds,
    startAtIdle: false
  },
);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
